<div class="container-fluid d-none d-md-block">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item hcm-breadcrumb-text">
                <a routerLink="/home">{{ 'stepper.home' | translate }}</a>
            </li>
            <li class="breadcrumb-item active hcm-breadcrumb-text" aria-current="page">
                {{ 'header.myHotCalls' | translate }}
            </li>
        </ol>
    </nav>
</div>
<div class="container-fluid">
    <h4 class="d-flex align-items-center m-1 pb-2 mt-2 gap-2">
        <img src="../../../../../assets/img/Icon.svg" alt="Back Icon" class="float-left img-icon me-2 cu"
            (click)="backToHome()" />
        <span class="hcm-nav-text">{{ 'activeHotCalls.title3' | translate }}</span>
    </h4>
    <form [formGroup]="myHotcallForm" class="row d-flex flex-wrap mb-1">
        <div class="col-12 d-flex align-items-center mb-md-2 cu flex-wrap">
            <div class="col-5 col-md-2 d-flex align-items-center mb-2 mb-md-0 px-1">
                <input type="text" formControlName="searchQuery"
                    [placeholder]="'activeHotCalls.search.ticket' | translate"
                    class="search-kanban me-1 pe-1 ps-0 w-100">
                <img src="../../../../../assets/img/search-icon.svg" alt="Search icon" class="float-right me-2">
            </div>
            <div class="col-7 col-md-2 px-2 mb-md-0">
                <mat-select formControlName="selectedStatus" class="w-100">
                    <mat-option value="" disabled hidden>{{ 'myHotCalls.status.select' | translate }}</mat-option>
                    <mat-option *ngFor="let status of statusOptions" [value]="status" [hidden]="!status">
                        {{getStatus(status.toLowerCase().replace(' ', '') | translate)}}</mat-option>
                </mat-select>
            </div>
            <div class="col-12 col-md-8 d-flex justify-content-end justify-content-md-end align-items-center mb-md-0">
                <span class="hcm-label mb-0 text-center text-md-end d-flex flex-nowrap align-items-center">
                    Sort by Create DT:
                    <img src="../../../../../assets/img/sort.svg" alt="Sort Icon" class="sort-icon pb-1 px-2"
                        (click)="toggleSortOrder()" [matTooltip]="sortState" />
                </span>
            </div>
        </div>
        <div *ngIf="filteredHotCalls.length > 0">
            <div class="virtual-scroll-container-wrapper">
                <cdk-virtual-scroll-viewport itemSize="120" class="virtual-scroll-container" [minBufferPx]="100"
                    [maxBufferPx]="200">

                    <div *cdkVirtualFor="let myHotCall of filteredHotCalls" class="mt-1">
                        <div appearance="outlined" class="mat-elevation-z4">
                            <div class="hot-call-top-border d-flex flex-wrap align-items-center col-12 pt-2 pb-2">
                                <!-- Ticket ID -->
                                <p class="col-6 col-md-2 mb-0 hcm-ticket-id-value text-md-start ps-3">
                                    {{myHotCall.ticketId}}</p>

                                <!-- Status -->
                                <p class="col-4 col-md-2 ps-md-2 mb-0 ms-3 ms-md-2 hcm-status-value hot-call-open-top-border"
                                    [ngClass]="getHotCallStatus(getStatus(myHotCall.ticketStatus))">
                                    {{getStatus(myHotCall.ticketStatus.toLowerCase().replace(' ', '') | translate)}}
                                </p>
                                <!-- Image (Visible only when status is ACCEPTED) -->
                                <img *ngIf="getStatus(myHotCall.ticketStatus) == 'Accepted'"
                                    class="col-2 col-md-3 hcm-active-img mb-0 ms-md-2  mt-md-0 mx-auto"
                                    src="../../../../../assets/img/flag.png" alt="Conveyance Status">
                            </div>
                            <mat-card-content>
                                <div class="row p-3 pb-0 mb-2">
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.seqScan' | translate
                                            }}
                                            <br><span class="hcm-value-text">{{myHotCall.seqScan}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.body' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.body}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.pcsRem' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.pcsRem}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.firstMissedSeq' |
                                            translate }} <br><span class="hcm-value-text">{{myHotCall.firMsdSeq}}</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.initialVehicles' |
                                            translate }} <br><span
                                                class="hcm-value-text">{{myHotCall.intVhcleEmpty}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.sp' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.sp}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.kb' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.kb}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.lmn' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.lineNm}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.dk' | translate }}
                                            <br><span class="hcm-value-text">{{myHotCall.dk}}</span>
                                        </p>
                                    </div>

                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.createdBy' | translate
                                            }}
                                            <br><div class="d-flex flex-md-column"><span class="me-3 hcm-value-text">{{myHotCall.crteBy}}</span>
                                            <span class="me-3 hcm-value-text">{{myHotCall.crteOn | date: 'MM/dd/yyyy hh:mm a' }}</span>
                                        </div>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{
                                            'activeHotCalls.ticketDetails.lastModified' | translate
                                            }}
                                            <br><div class="d-flex flex-md-column"><span class="me-3 hcm-value-text">{{myHotCall.updtBy}}</span>
                                            <span class="me-3 hcm-value-text">{{myHotCall.updtOn | date: 'MM/dd/yyyy hh:mm a' }}</span>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </mat-card-content>
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
        <div *ngIf="!isLoading && filteredHotCalls.length == 0">
            <div class="d-flex justify-content-center align-items-center mt-5">
                <p>No Data available</p>
            </div>
        </div>
    </form>
</div>